import { useEffect, useState } from 'react'
import logoIP from '../img/logoInfernalParadise.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { AuthServices } from '../util/authServices'

const Resgistra = ({ setUserSession, setViewAdminZone, userSession, setIdProcesamientoScort, idProcesamientoScort, setCargando, toast }) => {

    const listOptionsKeys = [
        { etiqueta: "Seleccione", valor: "0" },
        { etiqueta: "Fecha nacimiento", valor: "FECHA_NACIMIENTO" },
        { etiqueta: "Color de piel", valor: "COLOR_DE_PIEL" },
        { etiqueta: "Tamaño de busto", valor: "TAMANO_DE_BUSTO" },
        { etiqueta: "Tamaño cola", valor: "TAMANO_COLA" },
        { etiqueta: "Contextura", valor: "CONTEXTURA" },
        { etiqueta: "Estatura", valor: "ESTATURA" },
        { etiqueta: "Color ojos", valor: "COLOR_OJOS" },
        { etiqueta: "Color pelo", valor: "COLOR_PELO" },
        { etiqueta: "Idiomas", valor: "IDIOMAS" },
        { etiqueta: "Intereses", valor: "INTERESES" },
        { etiqueta: "Comida", valor: "COMIDA" },
        { etiqueta: "Bebida", valor: "BEBIDA" },
        { etiqueta: "Estilo de ropa", valor: "ESTILO_ROPA" },
        { etiqueta: "Cirugia estética", valor: "CIRUGIA_ESTETICA" },
        { etiqueta: "Cargo", valor: "CARGO" },
        { etiqueta: "Tipo Cuenta", valor: "TIPO_CUENTA" },
        { etiqueta: "Número de Cuenta", valor: "NO_DE_CUENTA" },
        { etiqueta: "Servicios adicionales", valor: "SERVICIOS_ADICIONALES" },
    ]

    const listOptionsCargos = ["Seleccione", "Gerente Administrativo", "Gerente Tecnologia", "Asistente Call Center", "Clienta", "Cliente"]
    const listOptionsTipoCuenta = ["Seleccione", "Ahorro", "Corriente"]
    const listOptionsColorPiel = ["Seleccione", "Blanca", "Trigueña", "Morena", "Negra"]
    const listOptionsTamanoBusto = ["Seleccione", "Pequeños", "Medianos", "Grandes"]
    const listOptionsTamanoCola = ["Seleccione", "Pequeña", "Mediana", "Grande"]
    const listOptionsContextura = ["Seleccione", "Delgada", "Robusta", "Atlética"]
    const listOptionsEstatura = ["Seleccione", "1,5 m", "1,6 m", "1,7 m", "1,8 m", "1,9 m", "2,0 m"]
    const listOptionsColorOjos = ["Seleccione", "Avellana", "Verde", "Azul", "Gris", "Castaño Ambar"]
    const listOptionsColorPelo = ["Seleccione", "Negro", "Castaño", "Rubio", "Peli Rojo"]

    const listOptionsUbicacion = ["Seleccione", "Bogotá ", "Medellin", "Cali", "Cartagena", "Santa Marta", "Barranquilla", "Manizales",
        "Ibague", "Villavicencio", "Armenia"]

    const listOptionsUsuarioTelegram = ["Seleccione", "IP_tecnologia"]

    const listExepcionesLavesDitail = ["TAMANO_DE_BUSTO", "COLOR_DE_PIEL", "TAMANO_COLA", "CONTEXTURA", "COLOR_OJOS", "COLOR_PELO"]

    const [idProcesamiento, setIdProcesamiento] = useState('0')

    const [indexSlider, setIndexSlider] = useState(0)
    const [currentImage, setCurrentImage] = useState(logoIP)
    const [objectImages, setObjectImages] = useState([])

    const [nombre, setNombre] = useState('')
    const [apellido, setApellido] = useState('')

    const [nombreArtistico, setNombreArtistico] = useState('')
    const [apellidoArtistico, setApellidoArtistico] = useState('')

    const [cedula, setCedula] = useState('')
    const [ciudad, setCiudad] = useState('')
    const [telefono, setTelefono] = useState('')
    const [telefonoPersonal, setTelefonoPersonal] = useState('')
    const [usuarioTelegram, setUsuarioTelegram] = useState('')
    const [descripcionScort, setDescripcionScort] = useState('')

    const [llaveDetail, setLlaveDetail] = useState('0')
    const [valorLlaveDetail, setValorLlaveDetail] = useState('')
    const [ditailsScortInsertList, setDitailsScortInsertList] = useState([])

    const [tarifa1, setTarifa1] = useState('');
    const [tarifa2, setTarifa2] = useState('');
    const [tarifa3, setTarifa3] = useState('');

    const [check1, setCheck1] = useState(true);
    const [check2, setCheck2] = useState(false);
    const [check3, setCheck3] = useState(false);

    const [archivos, setArchivos] = useState([]);

    const [disableNombre, setDisableNombre] = useState(false);
    const [disableApellido, setDisableApellido] = useState(false);
    const [disableDocumento, setDisableDocumento] = useState(false);

    useEffect(() => {
        if (idProcesamientoScort !== '0') {
            setIdProcesamiento(idProcesamientoScort);
            setIdProcesamientoScort('0');
            cargarRegistroScortEdita();
        }
    }, [])

    const closeSession = () => {
        setUserSession({
            nombre: "",
            apellido: "",
            usuario: "",
            role: "USUARIO_LOGIN"
        })
        sessionStorage.removeItem('userSessionStorage')
    }

    const actionNavigate = (action) => {
        setViewAdminZone(action)
    }

    const setDescriptionScortValue = (e) => {
        setDescripcionScort(e.target.value)
    }

    const selectDetailKey = (e) => {
        setValorLlaveDetail('')
        setLlaveDetail(e.target.value)
    }

    const addDetailList = () => {
        if (llaveDetail !== '0') {
            const objectKey = listOptionsKeys.filter((keys) => {
                return keys.valor === llaveDetail
            })
            let validaDitailExist = true;
            ditailsScortInsertList.map((detail) => {
                if (detail.idEtiqueta === objectKey[0].valor) {
                    if (listExepcionesLavesDitail.includes(detail.idEtiqueta)) {
                        validaDitailExist = false;
                    }
                }
            })
            if (validaDitailExist) {
                setDitailsScortInsertList([
                    ...ditailsScortInsertList, {
                        idEtiqueta: objectKey[0].valor,
                        llave: objectKey[0].etiqueta,
                        valor: valorLlaveDetail
                    }
                ])
                setLlaveDetail('0')
                setValorLlaveDetail('')
            } else {
                toast(`Ya existe: ${objectKey[0].etiqueta}`)
            }
        }
    }

    const removeDetailList = (ditailsScort) => {
        setDitailsScortInsertList(ditailsScortInsertList.filter((detail) => detail !== ditailsScort))
    }

    const eventInputFiles = (e) => {
        const fileList = e.target.files;
        let valorFinalMB = 0;
        for (let step = 0; step < fileList.length; step++) {
            var fileSizeMB = fileList[step].size / 1024 / 1024;
            valorFinalMB = valorFinalMB + fileSizeMB;
        }
        if (valorFinalMB < 20) {
            setArchivos(e.target.files)
        } else {
            toast("*Los archivos cargados superan las 20 MB")
        }
    }

    const chanceSliderImage = () => {
        let indDot = indexSlider + 1;
        if (indexSlider >= objectImages.length - 1) {
            indDot = 0
        }
        setIndexSlider(indDot)
        chanceSlider(indDot)
    }

    const chanceSlider = (indDot) => {
        setIndexSlider(indDot)
        setCurrentImage(objectImages[indDot].url)
        setObjectImages(objectImages.map((image, i) => {
            image.classDot = i === indDot ? 'div-dots-active' : 'div-dots'
            return image
        }))
    }

    const tipoValorLlaveDetail = (llaveDetail) => {

        switch (llaveDetail) {
            case '0':
                return (
                    <></>
                )
            case 'FECHA_NACIMIENTO':
                return (
                    <input type='date' name='valor' value={valorLlaveDetail} onChange={(e) => setValorLlaveDetail(e.target.value)}
                        className='form-control' autoComplete='off' />
                )
            case 'CARGO':
                return (
                    <select className='form-control' value={valorLlaveDetail} onChange={(e) => setValorLlaveDetail(e.target.value)}>
                        {
                            listOptionsCargos.map((key, i) => {
                                return (
                                    <option key={i} value={key}>{key}</option>
                                )
                            })
                        }
                    </select>
                )
            case 'COLOR_DE_PIEL':
                return (
                    <select className='form-control' value={valorLlaveDetail} onChange={(e) => setValorLlaveDetail(e.target.value)}>
                        {
                            listOptionsColorPiel.map((key, i) => {
                                return (
                                    <option key={i} value={key}>{key}</option>
                                )
                            })
                        }
                    </select>
                )
            case 'TIPO_CUENTA':
                return (
                    <select className='form-control' value={valorLlaveDetail} onChange={(e) => setValorLlaveDetail(e.target.value)}>
                        {
                            listOptionsTipoCuenta.map((key, i) => {
                                return (
                                    <option key={i} value={key}>{key}</option>
                                )
                            })
                        }
                    </select>
                )
            case 'TAMANO_DE_BUSTO':
                return (
                    <select className='form-control' value={valorLlaveDetail} onChange={(e) => setValorLlaveDetail(e.target.value)}>
                        {
                            listOptionsTamanoBusto.map((key, i) => {
                                return (
                                    <option key={i} value={key}>{key}</option>
                                )
                            })
                        }
                    </select>
                )
            case 'TAMANO_COLA':
                return (
                    <select className='form-control' value={valorLlaveDetail} onChange={(e) => setValorLlaveDetail(e.target.value)}>
                        {
                            listOptionsTamanoCola.map((key, i) => {
                                return (
                                    <option key={i} value={key}>{key}</option>
                                )
                            })
                        }
                    </select>
                )
            case 'CONTEXTURA':
                return (
                    <select className='form-control' value={valorLlaveDetail} onChange={(e) => setValorLlaveDetail(e.target.value)}>
                        {
                            listOptionsContextura.map((key, i) => {
                                return (
                                    <option key={i} value={key}>{key}</option>
                                )
                            })
                        }
                    </select>
                )
            case 'COLOR_PELO':
                return (
                    <select className='form-control' value={valorLlaveDetail} onChange={(e) => setValorLlaveDetail(e.target.value)}>
                        {
                            listOptionsColorPelo.map((key, i) => {
                                return (
                                    <option key={i} value={key}>{key}</option>
                                )
                            })
                        }
                    </select>
                )
            case 'ESTATURA':
                return (
                    <select className='form-control' value={valorLlaveDetail} onChange={(e) => setValorLlaveDetail(e.target.value)}>
                        {
                            listOptionsEstatura.map((key, i) => {
                                return (
                                    <option key={i} value={key}>{key}</option>
                                )
                            })
                        }
                    </select>
                )
            case 'COLOR_OJOS':
                return (
                    <select className='form-control' value={valorLlaveDetail} onChange={(e) => setValorLlaveDetail(e.target.value)}>
                        {
                            listOptionsColorOjos.map((key, i) => {
                                return (
                                    <option key={i} value={key}>{key}</option>
                                )
                            })
                        }
                    </select>
                )
            default:
                return (
                    <input type='text' name='valor' value={valorLlaveDetail} onChange={(e) => setValorLlaveDetail(e.target.value)}
                        className='form-control' autoComplete='off' />
                )
        }
    }

    const enviaInformacionPostImage = async () => {
        if (archivos.length > 0) {
            setCargando(true)
            const authServices = new AuthServices();
            try {
                const body = {
                    "idProcesamiento": idProcesamiento,
                    "totalImagenes": archivos.length,
                    "archivos": Array.from(archivos).map(file => ({
                        name: file.name,
                        type: file.type,
                        size: file.size
                    }))
                };
                const response = await authServices.requestPost(body, 17);
                const { estado, mensaje, objeto } = response.data;
                if (estado) {
                    await Promise.all(
                        Array.from(archivos).map((file, index) =>
                            authServices.requestPutFileUrlPresigned(file, objeto.objectKeysUrls[index], file.type)
                        )
                    );
                    clearCacheData()
                    setIdProcesamiento(objeto.idProcesamiento)
                    getImageScortsList(objeto.idProcesamiento)
                } else {
                    toast(mensaje)
                }
                setCargando(false)
            } catch (error) {
                setCargando(false)
                toast('Error de comunicación')
            }
        } else {
            toast('Seleccione los archivos que desea cargar')
        }
    }

    const getImageScortsList = async (idProcesamiento) => {
        setCargando(true)
        const authServices = new AuthServices();
        try {
            const body = {
                "idProcesamiento": idProcesamiento,
            };
            const response = await authServices.requestPost(body, 18);
            const { estado, mensaje, objeto } = response.data;
            if (estado) {
                setObjectImages(Array.from(objeto.scortImagesList))
                setCurrentImage(Array.from(objeto.scortImagesList)[0].url)
                setArchivos([])
            } else {
                toast(mensaje)
            }
            setCargando(false)
        } catch (error) {
            setCargando(false)
            toast('Error de comunicación')
        }
    }

    const cargarRegistroScort = async () => {
        if (nombre.length > 2 && apellido.length > 2 && cedula.length > 2 && idProcesamiento !== '0' && telefono.length > 4) {
            setCargando(true)
            const authServices = new AuthServices();
            try {
                const body = {
                    "idProcesamiento": idProcesamiento,
                    "nombreScort": nombre,
                    "apellidoScort": apellido,
                    "nombreArtisticoScort": nombreArtistico,
                    "apellidoArtisticoScort": apellidoArtistico,
                    "identificaionScort": cedula,
                    "ciudadScort": ciudad,
                    "telefonoScort": telefono,
                    "telefonoPersonalScort": telefonoPersonal,
                    "usuarioTelegram": usuarioTelegram,
                    "descripcionScort": descripcionScort,
                    "tarifa1": tarifa1,
                    "tarifa2": tarifa2,
                    "tarifa3": tarifa3,
                    "perfil1": check1,
                    "perfil2": check2,
                    "perfil3": check3,
                    "detallesScort": JSON.stringify(ditailsScortInsertList)
                };
                const response = await authServices.requestPost(body, 16);
                const { estado, mensaje } = response.data;
                if (estado) {
                    setViewAdminZone('VISTA_PRELIMINAR')
                }
                toast(mensaje)
                setCargando(false)
            } catch (error) {
                setCargando(false);
                toast("Error de comunicación")
            }
        } else {
            toast('Algunos campos son requeridos')
        }
    }

    const cargarRegistroScortEdita = async () => {
        setCargando(true)
        const authServices = new AuthServices();
        try {
            const body = {
                "idProcesamiento": idProcesamientoScort
            }
            const response = await authServices.requestPost(body, 15);
            const { estado, mensaje, objeto } = response.data;
            if (estado) {
                setNombre(objeto.nombre)
                setApellido(objeto.apellido)
                setNombreArtistico(objeto.nombreArtistico)
                setApellidoArtistico(objeto.apellidoArtistico)
                setCedula(objeto.cedula)
                setCiudad(objeto.ciudad)
                setTelefono(objeto.telefono)
                setTelefonoPersonal(objeto.telefonoPersonal)
                setUsuarioTelegram(objeto.usuarioTelegram)
                setDescripcionScort(objeto.descripcionScort)
                setTarifa1(objeto.tarifa1)
                setTarifa2(objeto.tarifa2)
                setTarifa3(objeto.tarifa3)
                setCheck1(objeto.perfil1)
                setCheck2(objeto.perfil2)
                setCheck3(objeto.perfil3)
                setDitailsScortInsertList(objeto.detalles)
                setObjectImages(Array.from(objeto.images))
                setCurrentImage(objeto.currentURL)
                setDisableNombre(false)
                setDisableApellido(false)
                setDisableDocumento(false)
            } else {
                toast(mensaje)
            }
            setCargando(false)
        } catch (error) {
            setCargando(false);
            toast("Error de comunicación")
        }
    }

    const clearCacheData = () => {
        caches.keys().then((names) => {
            names.forEach((name) => {
                caches.delete(name);
            });
        });
    };

    const getTarifaDisplay = (valStr, multiplier) => {
        if (valStr === undefined || valStr === null || valStr === '') return '';
        const cleanStr = String(valStr).replace(/[\$\.\s]/g, '');
        const num = parseInt(cleanStr, 10);
        if (isNaN(num)) return valStr;
        const result = num * multiplier;
        return result.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };

    const sectionCardStyle = {
        backgroundColor: 'rgba(255, 255, 255, 0.02)',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        borderRadius: '12px',
        padding: '25px',
        marginBottom: '30px',
        boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.37)'
    };

    const subCardStyle = {
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
        border: '1px solid rgba(255, 255, 255, 0.05)',
        borderRadius: '8px',
        padding: '20px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    };

    const sectionTitleStyle = {
        fontSize: '1.2rem',
        fontWeight: '600',
        color: '#FF1A1A',
        marginBottom: '20px',
        borderBottom: '2px solid rgba(255, 26, 26, 0.2)',
        paddingBottom: '8px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
    };

    return (
        <>
            <div className='div-container'>
                <div className="row m-0">
                    <div className="col-6 col-sm-6 col-md-6 col-lg-6" >
                        <div className='div-name-user'>
                            <p>{`${userSession.nombre} ${userSession.apellido}`}</p>
                        </div>
                    </div>
                    <div className="col-6 col-sm-6 col-md-6 col-lg-6 control-margin" >
                        <div className='div-close-info' style={{ height: "3rem" }}>
                            <button className='btn btn-link btn-close-modal' onClick={() => actionNavigate('HOME')} >Volver a menú</button>
                            <button className='btn btn-link btn-close-modal' onClick={() => closeSession()} >Cerrar</button>
                        </div>
                    </div>
                </div>
                <hr className='hr-report' />
            </div>

            {/* SECCIÓN 1: DATOS PERSONALES */}
            <div className='div-container' style={sectionCardStyle}>
                <h3 style={sectionTitleStyle}>Datos Personales y Ubicación</h3>
                <div className="row m-0">
                    <div className="col-12 col-sm-6 col-md-4 col-lg-4" >
                        <div className='div-inputs-login'>
                            <p className='p-label-form'> Nombre </p>
                            {
                                disableNombre ?
                                    <input type="text" name='nombre' value={nombre} onChange={(e) => setNombre(e.target.value)} disabled
                                        className='form-control' autoComplete='off' />
                                    :
                                    <input type="text" name='nombre' value={nombre} onChange={(e) => setNombre(e.target.value)} className='form-control'
                                        autoComplete='off' />
                            }
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-4 col-lg-4" >
                        <div className='div-inputs-login'>
                            <p className='p-label-form'> Apellido </p>
                            {
                                disableApellido ?
                                    <input type="text" name='apellido' value={apellido} onChange={(e) => setApellido(e.target.value)} disabled
                                        className='form-control' autoComplete='off' />
                                    :
                                    <input type="text" name='apellido' value={apellido} onChange={(e) => setApellido(e.target.value)} className='form-control'
                                        autoComplete='off' />
                            }
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-4 col-lg-4" >
                        <div className='div-inputs-login'>
                            <p className='p-label-form'> No documento </p>
                            {
                                disableDocumento ?
                                    <input type="text" name='documento' value={cedula} onChange={(e) => setCedula(e.target.value)} disabled
                                        className='form-control' autoComplete='off' />
                                    :
                                    <input type="text" name='documento' value={cedula} onChange={(e) => setCedula(e.target.value)} className='form-control'
                                        autoComplete='off' />
                            }
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 mt-3" >
                        <div className='div-inputs-login'>
                            <p className='p-label-form'> Ciudad </p>
                            <select name='ciudad' className='form-control' value={ciudad} onChange={(e) => setCiudad(e.target.value)}>
                                {
                                    listOptionsUbicacion.map((key, i) => {
                                        return (
                                            <option key={i} value={key}>{key}</option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 mt-3" >
                        <div className='div-inputs-login'>
                            <p className='p-label-form'> Teléfono Personal </p>
                            <input type="text" name='telefonoPersonal' value={telefonoPersonal} onChange={(e) => setTelefonoPersonal(e.target.value)}
                                className='form-control' autoComplete='off' />
                        </div>
                    </div>
                </div>
            </div>

            {/* SECCIÓN 2: PERFIL ARTÍSTICO Y CANALES DE VENTA */}
            <div className='div-container' style={sectionCardStyle}>
                <h3 style={sectionTitleStyle}>Perfil Artístico y Canales de Venta</h3>
                <div className="row m-0">
                    <div className="col-12 col-sm-6 col-md-6 col-lg-6" >
                        <div className='div-inputs-login'>
                            <p className='p-label-form'> Nombre Artístico </p>
                            <input type="text" name='nombreArtistico' value={nombreArtistico} onChange={(e) => setNombreArtistico(e.target.value)}
                                className='form-control' autoComplete='off' />
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-6 col-lg-6" >
                        <div className='div-inputs-login'>
                            <p className='p-label-form'> Apellido Artístico</p>
                            <input type="text" name='apellidoArtistico' value={apellidoArtistico} onChange={(e) => setApellidoArtistico(e.target.value)}
                                className='form-control' autoComplete='off' />
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 mt-3" >
                        <div className='div-inputs-login'>
                            <p className='p-label-form'> Teléfono de contacto IP </p>
                            <input type="text" name='telefono' value={telefono} onChange={(e) => setTelefono(e.target.value)}
                                className='form-control' autoComplete='off' />
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 mt-3" >
                        <div className='div-inputs-login'>
                            <p className='p-label-form'> Usuario Telegram </p>
                            <select name='ciudad' className='form-control' value={usuarioTelegram} onChange={(e) => setUsuarioTelegram(e.target.value)}>
                                {
                                    listOptionsUsuarioTelegram.map((key, i) => {
                                        return (
                                            <option key={i} value={key}>{key}</option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                    </div>
                    <div className="col-12 mt-4" >
                        <div className='div-inputs-login w-100'>
                            <p className='p-label-form' style={{ fontWeight: '500' }}> Categoría / Perfil Escort </p>
                            <div className="d-flex flex-wrap gap-4 mt-2">
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" onChange={() => setCheck1(!check1)} checked={check1} id="flexCheck1" style={{ cursor: 'pointer' }} />
                                    <label className="form-check-label text-white" htmlFor="flexCheck1" style={{ cursor: 'pointer' }}>
                                        Escort
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" onChange={() => setCheck2(!check2)} checked={check2} id="flexCheck2" style={{ cursor: 'pointer' }} />
                                    <label className="form-check-label text-white" htmlFor="flexCheck2" style={{ cursor: 'pointer' }}>
                                        Acompañante
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" onChange={() => setCheck3(!check3)} checked={check3} id="flexCheck3" style={{ cursor: 'pointer' }} />
                                    <label className="form-check-label text-white" htmlFor="flexCheck3" style={{ cursor: 'pointer' }}>
                                        Call Girls
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* SECCIÓN 3: TARIFAS Y DESCRIPCIÓN */}
            <div className='div-container' style={sectionCardStyle}>
                <h3 style={sectionTitleStyle}>Tarifas y Descripción</h3>
                <div className="row m-0 g-4">
                    {/* COLUMNA TARIFAS */}
                    <div className="col-12 col-md-5 pe-md-2 d-flex flex-column mt-0" >
                        <div style={subCardStyle}>
                            <div>
                                <h4 style={{ color: '#fff', fontSize: '1.05rem', marginBottom: '10px', fontWeight: '500' }}>Tarifas</h4>
                                <p style={{ fontSize: '0.82rem', color: '#a0a0a0', marginTop: '-5px', marginBottom: '15px', lineHeight: '1.4' }}>
                                    * Ingrese el valor base por hora para cada tarifa. El sistema calculará el total automáticamente (multiplicando por 3 o por 5 según corresponda) en la previsualización y de cara al cliente.
                                    <br />
                                    <span style={{ color: '#ff1a1a', opacity: '0.9' }}><em>Ejemplo: si la hora de la tarifa de 3 horas es a 80.000, ingrese 80.000 (el sistema mostrará $240.000).</em></span>
                                </p>
                            </div>
                            <div>
                                <div className='div-info-economica'>
                                    <div className="row m-0 w-100 div-label-parrafo-tarifa">
                                        <div className="col-6 col-sm-6 col-md-6 col-lg-6" ><p style={{ margin: 0 }}>1 hora</p></div>
                                        <div className="col-6 col-sm-6 col-md-6 col-lg-6" >
                                            <input type='text' name='tarifa1' value={tarifa1} onChange={(e) => setTarifa1(e.target.value)} className='form-control'
                                                autoComplete='off' />
                                        </div>
                                    </div>
                                </div>
                                <div className='div-info-economica'>
                                    <div className="row m-0 w-100 div-label-parrafo-tarifa">
                                        <div className="col-6 col-sm-6 col-md-6 col-lg-6" ><p style={{ margin: 0 }}>3 horas</p></div>
                                        <div className="col-6 col-sm-6 col-md-6 col-lg-6" >
                                            <input type='text' name='tarifa2' value={tarifa2} onChange={(e) => setTarifa2(e.target.value)} className='form-control'
                                                autoComplete='off' />
                                        </div>
                                    </div>
                                </div>
                                <div className='div-info-economica' style={{ marginBottom: 0 }}>
                                    <div className="row m-0 w-100 div-label-parrafo-tarifa">
                                        <div className="col-6 col-sm-6 col-md-6 col-lg-6" ><p style={{ margin: 0 }}>5 horas</p></div>
                                        <div className="col-6 col-sm-6 col-md-6 col-lg-6" >
                                            <input type='text' name='tarifa3' value={tarifa3} onChange={(e) => setTarifa3(e.target.value)} className='form-control'
                                                autoComplete='off' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* COLUMNA DESCRIPCIÓN */}
                    <div className="col-12 col-md-7 ps-md-2 mt-4 mt-md-0 d-flex flex-column" >
                        <div style={subCardStyle}>
                            <div>
                                <h4 style={{ color: '#fff', fontSize: '1.05rem', marginBottom: '10px', fontWeight: '500' }}>Descripción detallada de la Scort</h4>
                                <p style={{ fontSize: '0.85rem', color: '#a0a0a0', marginTop: '-5px', marginBottom: '15px' }}>
                                    Escriba una presentación atractiva e información relevante para el perfil.
                                </p>
                            </div>
                            <div className="div-ajusta-content w-100 mt-2">
                                <textarea value={descripcionScort} onChange={(e) => setDescriptionScortValue(e)} className='input-textarea-descripcion' style={{ borderRadius: '6px', border: '1px solid rgba(255,255,255,0.15)', background: '#1c1c1c', color: '#fff', padding: '10px', height: '12rem', marginBottom: 0 }}></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* SECCIÓN 4: DETALLES Y MULTIMEDIA */}
            <div className='div-container' style={sectionCardStyle}>
                <h3 style={sectionTitleStyle}>Multimedia y Detalles Técnicos</h3>
                <div className="row m-0 g-4">
                    {/* COLUMNA MULTIMEDIA */}
                    <div className="col-12 col-md-6 pe-md-2 d-flex flex-column mt-0" >
                        <div style={subCardStyle}>
                            <div>
                                <h4 style={{ color: '#fff', fontSize: '1.05rem', marginBottom: '15px', fontWeight: '500' }}>Imágenes de Galería</h4>
                                <p style={{ fontSize: '0.82rem', color: '#a0a0a0', marginTop: '-5px', marginBottom: '15px' }}>
                                    Seleccione una o más imágenes de su dispositivo para subir a la galería del perfil (peso máximo total: 20 MB).
                                </p>
                                <div className='div-inputs-login w-100'>
                                    <input type="file" className='form-control' multiple onChange={(e) => eventInputFiles(e)} accept="image/*" />
                                    {archivos && archivos.length > 0 && (
                                        <div className="mt-2 px-2 py-1" style={{ fontSize: '0.8rem', color: '#6adfff', background: 'rgba(106, 223, 255, 0.1)', borderRadius: '6px', border: '1px solid rgba(106, 223, 255, 0.2)', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                                            <span style={{ display: 'inline-block', width: '6px', height: '6px', backgroundColor: '#6adfff', borderRadius: '50%' }}></span>
                                            {archivos.length} archivos seleccionados
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className='div-inputs-login mt-4 w-100'>
                                <button className='btn btn-primary custom-btn w-100' onClick={() => enviaInformacionPostImage()} style={{ padding: '10px 0', fontWeight: 'bold' }}>
                                    Cargar Imágenes
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* COLUMNA DETALLES TÉCNICOS */}
                    <div className="col-12 col-md-6 ps-md-2 mt-4 mt-md-0 d-flex flex-column" >
                        <div style={subCardStyle}>
                            <div>
                                <h4 style={{ color: '#fff', fontSize: '1.05rem', marginBottom: '15px', fontWeight: '500' }}>Agregar Detalle Adicional</h4>
                                <p style={{ fontSize: '0.82rem', color: '#a0a0a0', marginTop: '-5px', marginBottom: '15px' }}>
                                    Agregue información complementaria al perfil (como estatura, color de ojos, cirugías, etc.).
                                </p>
                                <div className="row g-3 m-0">
                                    <div className="col-12 col-sm-6 p-0 pe-sm-2" >
                                        <div className='div-inputs-login w-100'>
                                            <label style={{ fontSize: '0.85rem', color: '#fff', marginBottom: '6px', opacity: '0.8' }}>Característica</label>
                                            <select className='form-control' value={llaveDetail} onChange={(e) => selectDetailKey(e)}>
                                                {
                                                    listOptionsKeys.map((key, i) => {
                                                        return (
                                                            <option key={i} value={key.valor}>{key.etiqueta}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6 p-0 ps-sm-2" >
                                        <div className='div-inputs-login w-100'>
                                            <label style={{ fontSize: '0.85rem', color: '#fff', marginBottom: '6px', opacity: '0.8' }}>Valor</label>
                                            {
                                                tipoValorLlaveDetail(llaveDetail)
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 p-0 mt-4" >
                                <div className='div-inputs-login w-100'>
                                    <button className='btn btn-primary custom-btn w-100' onClick={() => addDetailList()} style={{ padding: '10px 0', fontWeight: 'bold' }}>
                                        Agregar Detalle
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* BOTÓN DE GUARDADO PRINCIPAL */}
            <div className='div-container text-center mb-0'>
                <button className='btn btn-primary custom-btn' onClick={() => cargarRegistroScort()} style={{ padding: '12px 40px', fontSize: '1.1rem', fontWeight: 'bold', minWidth: '220px', borderRadius: '30px' }}>
                    Guardar / Cargar Scort
                </button>
            </div>

            <hr className='hr-report mt-3' />
            <div className='div-container'>
                <div className="row m-0">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 "  >
                        <div className='div-info-scort-details'>
                            <p className='text-info-scort-nombre'> {nombreArtistico} <font> {apellidoArtistico} </font></p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 "  >
                        <div className='div-target-details-padre'>
                            <div className='div-info-scort-details'>
                                <p className=''>{descripcionScort} </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 " >
                        <div className='div-target-details-padre' >
                            <div className=''>
                                <img src={currentImage} alt='' className='img-scort-details' onClick={() => chanceSliderImage()} ></img>
                            </div>
                            <div className='div-dots-padre' style={{ bottom: "35px" }}>
                                {
                                    objectImages.map((image, i) => {
                                        return (
                                            <div key={i} className={image.classDot} onClick={() => chanceSlider(i)} ></div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 ">
                        <div className='div-target-details-padre'>
                            <div className="row m-0 w-100 div-info-scort-details">
                                <div className='div-info-economica-padre'>
                                    <p className='text-info-scort-nombre'><font>Tarifas</font></p>
                                    <br />
                                    <div className='div-info-economica'>
                                        <p >1 hora </p>
                                        <p >${getTarifaDisplay(tarifa1, 1)}</p>
                                    </div>
                                    <div className='div-info-economica'>
                                        <p >3 horas </p>
                                        <p >${getTarifaDisplay(tarifa2, 3)}</p>
                                    </div>
                                    <div className='div-info-economica'>
                                        <p >5 horas </p>
                                        <p >${getTarifaDisplay(tarifa3, 5)}</p>
                                    </div>
                                </div>
                                <div className='div-info-economica-padre'></div>
                            </div>
                        </div>
                        <div className='div-target-details-padre'>
                            <div className='div-info-scort-details'>
                                <p className='text-info-scort-nombre'><font> Detalles </font></p>
                            </div>
                            <div className='div-info-scort-details'>
                                {
                                    ditailsScortInsertList.map((detailObject, i) => {
                                        if (detailObject.llave === 'Fecha nacimiento') {
                                            var hoy = new Date();
                                            var cumpleanos = new Date(detailObject.valor);
                                            var edad = hoy.getFullYear() - cumpleanos.getFullYear();
                                            var m = hoy.getMonth() - cumpleanos.getMonth();
                                            if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
                                                edad--;
                                            }
                                            return (
                                                <div key={i} className="row m-0 div-row-info">
                                                    <div className="col-5 ">
                                                        <p className='text-info-1'>Edad </p>
                                                    </div>
                                                    <div className="col-5 " >
                                                        <p className='text-info-2'> {edad}</p>
                                                    </div>
                                                    <div className="col-2 " >
                                                        <FontAwesomeIcon className='icon-close-detail-registra' icon={faXmark} onClick={() =>
                                                            removeDetailList(detailObject)} />
                                                    </div>
                                                </div>
                                            )
                                        } else {
                                            return (
                                                <div key={i} className="row m-0 div-row-info">
                                                    <div className="col-5 ">
                                                        <p className='text-info-1'>{detailObject.llave} </p>
                                                    </div>
                                                    <div className="col-5 " >
                                                        <p className='text-info-2'> {detailObject.valor}</p>
                                                    </div>
                                                    <div className="col-2 " >
                                                        <FontAwesomeIcon className='icon-close-detail-registra' icon={faXmark} onClick={() =>
                                                            removeDetailList(detailObject)} />
                                                    </div>
                                                </div>
                                            )
                                        }
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Resgistra